// @flow
import * as React from 'react';
import {
    Box, Text, ThemeContext,
} from 'grommet';
import Button from 'esm-web-pro/components/layout/GreyButton';
import { Next, Previous } from 'grommet-icons';
import styled from 'styled-components';
import RcPagination from 'esm-web-pro/containers/tables/pagination/RcPagination';

type Props = {
    offset: number,
    pageSize: number,
    count: number,
    onPageChange: (page: number) => void,
    // onPageSizeChange: (pageSize: number) => void,
}

const StyledButton = styled(Button)`
    border-radius: 5px;
    height: 22px;
`;

class Pagination extends React.Component<Props> {
    static defaultProps = {
        pageSize: 10,
    };

    constructor(props: Props) {
        super(props);

        this.pageInput = React.createRef();
    }

    getPagination = () => {
        const { count, pageSize, offset } = this.props;

        return {
            pages: Math.ceil((count / pageSize) || 1),
            currentPage: ((offset / pageSize) || 0) + 1,
        };
    };

    // handlePageSizeChange = ({ option }) => {
    //     const { onPageSizeChange } = this.props;
    //     onPageSizeChange(option);
    // };

    handlePageSelectChange = ({ option }) => {
        const { onPageChange } = this.props;
        onPageChange(option - 1);
    };

    handlePageChange = (current, pageSize) => {
        const { onPageChange } = this.props;
        onPageChange(current - 1);
    };

    handleNextPageChange = () => {
        const { onPageChange } = this.props;
        onPageChange(this.getPagination().currentPage);
    };

    handlePrevPageChange = () => {
        const { onPageChange } = this.props;
        onPageChange(this.getPagination().currentPage - 2);
    };

    render(): React.ReactNode {
        const { pageSize, count } = this.props;
        const page = this.getPagination();

        return (
            <ThemeContext.Consumer>
                {(theme: Object) => (
                    <ThemeContext.Extend value={theme?.pagination}>
                        <Box
                            direction="row"
                            width="100%"
                            align="center"
                            justify="center"
                            pad={{ horizontal: 'small', bottom: 'small' }}
                            flex={{ shrink: 0 }}
                        >
                            <RcPagination
                                key={`${page.currentPage} ${page.pages}`}
                                className="rc-pagination"
                                total={count}
                                defaultPageSize={pageSize}
                                current={page.currentPage}
                                onChange={this.handlePageChange}
                                showTitle={false}
                                prevIcon={(
                                    <Box pad={{ horizontal: 'xsmall' }}>
                                        <StyledButton
                                            disabled={page.currentPage === 1}
                                            icon={<Previous size="small" align="center" />}
                                            plain={false}
                                            onClick={this.handlePrevPageChange}
                                            size="small"
                                        />
                                    </Box>
                                )}
                                nextIcon={(
                                    <Box pad={{ horizontal: 'xsmall' }}>
                                        <StyledButton
                                            disabled={page.currentPage >= page.pages}
                                            icon={<Next size="small" />}
                                            plain={false}
                                            onClick={this.handleNextPageChange}
                                            size="small"
                                        />
                                    </Box>
                                )}
                                jumpPrevIcon={<Text>...</Text>}
                                jumpNextIcon={<Text>...</Text>}
                                itemRender={(current, type, el) => {
                                    if (type === 'page' && current !== page.pages && current !== 0) {
                                        if ((page.currentPage === 1 || page.currentPage === 2 || page.currentPage === 3)
                                            && current > 4 && page.pages > 7) {
                                            return el;
                                        }
                                        if (page.currentPage === 4 && current > page.currentPage + 1
                                            && page.pages > 7) {
                                            return el;
                                        }
                                        if (page.currentPage > 4 && (current <= 1
                                            || (current > page.currentPage + 1 && current < page.pages - 1))
                                            && page.pages > 7) {
                                            return el;
                                        }
                                        return (
                                            <Box direction="row">
                                                {el}
                                                <Box pad={{ horizontal: '2px' }} justify="center">
                                                    <Text weight={400}>-</Text>
                                                </Box>
                                            </Box>
                                        );
                                    }
                                    return el;
                                }}
                            />
                        </Box>
                    </ThemeContext.Extend>
                )}
            </ThemeContext.Consumer>
        );
    }
}

export default Pagination;
